import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import ConnectWithUsForm from './ConnectUs';

const ContactUs = () => {
    return (
        <div className="contact-us-container">
            <div className="contact-us-header">
                <h1 className="contact-us-title">Get in Touch with Us</h1>
                <p className="contact-us-description">
                    We're here to help and answer any questions you might have. Reach out to us!
                </p>
            </div>

            {/* <div className="contact-us-info">
                <div className="contact-card">
                    <Phone className="contact-icon" />
                    <h3>Phone</h3>
                    <p className="contact-detail">81084 46414, 18002032499</p>
                </div>
                <div className="contact-card">
                    <Mail className="contact-icon" />
                    <h3>Email</h3>
                    <p className="contact-detail">omsaienterprise12service@gmail.com</p>
                </div>
                <div className="contact-card">
                    <MapPin className="contact-icon" />
                    <h3>Head Office</h3>
                    <p className="contact-detail">Lokhandwala, Kandivali East, Mumbai 400101</p>
                </div>
            </div> */}

            <ConnectWithUsForm />

        </div>
    );
};

export default ContactUs;
